import { Directive } from '@angular/core';
import { Subscription } from 'rxjs';
import { BackgroundService } from '../services/background.service';

@Directive({
  selector: '[appSetBackground]',
  standalone: true,
})
export class SetBackgroundDirective {
  subscription: Subscription;

  constructor(private backgroundService: BackgroundService) {
    this.subscription = this.backgroundService.backgroundColor$.subscribe((color) => {
      if (color) {
        document.body.style.backgroundColor = color;
        document.body.style.backgroundImage = 'unset';
      } else {
        document.body.style.backgroundColor = '#ffffff';
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
